import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import { IconButton, Tooltip } from '@material-ui/core'
import Keyboard from '@material-ui/icons/Keyboard'
import PolicyIcon from '@material-ui/icons/Policy'

// Default options for tool tip
const initOptions = {
  color: 'rgba(0, 0, 0, 0.87)',
  fontSize: 12,
  leaveTouchDelay: 10000
}

/**
 * Function determines the time of icon that needs to be displayed when a source is identified
 * @param {String} source source type whether it's the keyboard or application
 * @param {Object} options options to change the tool tip accompanying it, if undefined it defaults to the initial options
 * @param {number} iconSize size of the icon, if undefined it defaults to 30
 */

const getSourceIcon = (source, handleFilter, options = initOptions, iconSize = 30) => {
  const LightTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: theme.palette.common.white,
      color: options.color,
      boxShadow: theme.shadows[1],
      fontSize: options.fontSize,
      leaveTouchDelay: options.leaveTouchDelay
    }
  }))(Tooltip)

  switch (source) {
    case 'Application': {
      return (
        <LightTooltip title='APPLICATION' placement='right'>
          <IconButton
            color='primary'
            className='p-0'
            onClick={() => handleFilter({ source: 1 })}
          >
            <PolicyIcon style={{ fontSize: iconSize }} />
          </IconButton>
        </LightTooltip>
      )
    }
    case 'Keyboard': {
      return (
        <LightTooltip title='KEYBOARD' placement='right'>
          <IconButton
            color='primary'
            className='p-0'
            onClick={() => handleFilter({ source: 0 })}
          >
            <Keyboard style={{ fontSize: iconSize }} />
          </IconButton>
        </LightTooltip>
      )
    }
    default: {
      return (
        <div />
      )
    }
  }
}

export default getSourceIcon
